import React, { useEffect, useState } from "react";
import PopupModal from "../../Components/ModalComponent/PopupModal";
import AlertBox from "../../Components/AlertBox/AlertBox";
import DataTable from "../../Components/DataTable/DataTable";
import { Popconfirm, Skeleton } from "@arco-design/web-react";
import { ManageApis } from "../../AppServices/ManageApi";
import { Button } from "react-bootstrap";
import { convertUtcToBrowserTimeZone, dataTableInitialLoader, formatDate } from "../../Functions/Utils";
import InputComponent2 from "../../Components/InputComponent/InputComponent2";
// import InputComponent2 from "../../Components/InputComponent copy/InputComponent2";
import Loader from "../../Components/LoaderComponent/Loader";
import MenuHeader from "../../Components/MenuHeaderSection/MenuHeader";

function Client() {
  const AlertinitialValue = {
    show: false,
    message: "",
    isfalse: false,
    isSuccess: false,
  };
  const [clientDataList, setClientDataList] = useState([]);
  const [data, setData] = useState([]);
  const [loader, setloader] = useState(false);
  const [tableLoader, setTableLoader] = useState(false);
  const [clientData, setClientData] = useState({});
  const [currentPage, setcurrentPage] = useState(1);
  const [visible, setvisible] = useState({ show: false, type: "" });
  const [showAlert, setShowAlert] = useState(AlertinitialValue);

  const handleEditClientName = (param) => {
    setvisible((pre) => ({ show: true, type: "edit_Client_Name" }));
    //console.log(param);

    setClientData((pre) => param);
  };

  const handleSubmit = async () => {
    try {
      setloader(true);
      setvisible((pre) => ({ show: false, type: "" }));
      let response;
      const { createdDate, id, name } = clientData;
      switch (visible?.type) {
        case "edit_Client_Name":
          response = await ManageApis("post", global.updateClientDetails, {
            id,
            name,
          });
          if (response.message === "Success") {
            setShowAlert((pre) => ({
              ...pre,
              show: true,
              message: response?.response_data?.message,
              isSuccess: true,
              isfalse: false,
            }));
            setloader(false);
            setClientData((pre) => ({}));
            getClientsListData();
          } else {
            setloader(false);

            setShowAlert((pre) => ({
              ...pre,
              show: true,
              message: response?.response_data?.message,

              isfalse: true,
            }));
          }

          break;
        case "new_Client":
          response = await ManageApis("post", global.addClientDetails, {
            name,
          });
          if (response.message === "Success") {
            setvisible((pre) => ({ show: false, type: "" }));
            setShowAlert((pre) => ({
              ...pre,
              show: true,
              message: response?.response_data?.message,
              isSuccess: true,
            }));
            setloader(false);
            setClientData((pre) => ({}));
            getClientsListData();
          } else {
            setShowAlert((pre) => ({
              ...pre,
              show: true,
              message: response?.response_data?.message,
              isfalse: true,
            }));
            setloader(false);
          }
          break;

        default:
          break;
      }
    } catch (error) {
      setloader(false);
      setvisible((pre) => ({ show: false, type: "" }));
      //console.log(error);
    }
  };
  const handleDeleteClient = async (param) => {
    try {
      setloader(true);
      const data = {
        id: param,
      };
      let result = await ManageApis("post", global.deleteClientDetails, data);
      if (result.message == "Success") {
        setShowAlert((pre) => ({
          ...pre,
          show: true,
          message: result?.response_data?.message,
          isSuccess: true,
        }));
        getClientsListData();
        setloader(false);
      } else {
        setShowAlert((pre) => ({
          ...pre,
          show: true,
          message: result?.response_data?.message,
          isfalse: true,
        }));
        setloader(false);
      }
    } catch (error) {
      setloader(false);
      //console.log(error);
    }
  };

  const TableColumn = [
    {
      title: "Name",
      dataIndex: "name",
      // sorter: (a, b) => {                            //not use currently if need sort uncomment it
      //   if (a.name > b.name) {
      //     return 1;
      //   }
      //   if (a.name < b.name) {
      //     return -1;
      //   }
      //   return 0;
      // },
      headerCellStyle: {
        backgroundColor: 'var(--mastercolor2)',
        color: '#fff'
      },
    },
    {
      title: "Created Date", dataIndex: "createdDate", headerCellStyle: {
        backgroundColor: 'var(--mastercolor2)',
        color: '#fff'
      },
      render: (v, record) => {
        return (<div>{convertUtcToBrowserTimeZone(record.createdDate)}</div>)
      }
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (v, record) => {
        //console.log({ record });
        return loader ? (
          <Skeleton text={{ rows: 1, width: 100 }} />
        ) : (
          <div className="col-12 ">
            <div className="d-flex flex-column flex-md-row  justify-content-center mt-3 mt-md-0  gap-2">
              <button
                className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100"
                onClick={() => handleEditClientName(record)}
              >
                Edit
              </button>

              <Popconfirm
                title="Are you Sure ?"
                okText={"OK"}
                cancelText={"Cancel"}
                onOk={() => handleDeleteClient(record.id)}
              >
                <button className="btn px_btn btn-master py-1 rounded fw_500 font_12 w-100">
                  Delete
                </button>
                {/* <DeleteTwoTone /> */}
              </Popconfirm>
            </div>
          </div>
        );
      },
      headerCellStyle: {
        backgroundColor: 'var(--mastercolor2)',
        color: '#fff'
      },
      width: "300px",
    },
  ];

  useEffect(() => {
    getClientsListData();
  }, []);

  const getClientsListData = async () => {
    try {
      setloader(true);
      setClientDataList(dataTableInitialLoader(TableColumn));
      let response = await ManageApis("get", global.getClientsList);
      //console.log(response);

      if (response.message === "Success") {
        setloader(false);
        setData(response?.response_data);
        setClientDataList((pre) => response?.response_data);
      } else {
        setloader(false);
        //console.log(response);
        setShowAlert((pre) => ({
          ...pre,
          show: true,
          message: response?.response_data?.message,
          isfalse: true,
        }));
      }
    } catch (error) {
      setloader(false);
      //console.log(error)
    }
  };
  // onchange function for pagination
  function onChangeTable(pagination) {
    // ""
    //console.log(pagination);
    const { current, pageSize } = pagination;
    setTableLoader(true);
    // setClientDataList(dataTableInitialLoader(TableColumn));
    //console.log("----->", data.slice((current - 1) * pageSize, current * pageSize))
    setClientDataList([]);
    setTimeout(() => {
      setClientDataList(
        data.slice((current - 1) * pageSize, current * pageSize)
      );


      setcurrentPage(current);
      setTableLoader(false);
    }, 2000);
  }
  const handleChange = (event) => {
    const { name, value } = event.target;
    if (visible?.type == "edit_Client_Name") {
      setClientData((pre) => ({ ...pre, name: value }));
    } else {
      setClientData((pre) => ({ name: value }));
    }
  };

  return (
    <>
      {loader && <Loader />}
      <AlertBox
        show={showAlert.show}
        message={showAlert.message}
        enableFailIcon={showAlert.isfalse}
        enableSuccessIcon={showAlert.isSuccess}
        handlecancel={() => setShowAlert(AlertinitialValue)}
      />

      <div className="px-3 ">
        <MenuHeader
          handleChange={() =>
            setvisible((pre) => ({
              ...pre,
              show: true,
              type: "new_Client",
            }))
          }
          btnLabel={"Add Client"}
          headerName={true}
        />

        {/* data table component for list data */}
        <DataTable
          columnData={TableColumn}
          rowData={clientDataList}
          loading={tableLoader}
          current={currentPage}
          total={data.length}
          onChangeTable={onChangeTable}
        />
      </div>

      {/* popup modal component with children passing */}
      <PopupModal
        title={visible?.type?.replaceAll("_", " ")}
        size="md"
        visible={visible.show}
        handleClose={() => {
          setvisible((pre) => ({ show: false, type: "" }));
          setClientData({});
        }}
      >
        <div>
          <InputComponent2
            label={"Client Name"}
            onchange={handleChange}
            value={clientData?.name}
          />
          <div>
            <button
              className="btn px_btn btn-master px-4 rounded fw_500 font_12 w-100"
              disabled={Object.keys(clientData).length == 0 || !clientData.name}
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </div>
      </PopupModal>
    </>
  );
}

export default Client;
